"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GET_SUBSCRIPTIONS_QUERY = "\n  query GetSubs {\n    user {\n      subscriptions {\n        id\n        title\n      }\n    }\n  }\n  ";
exports.default = GET_SUBSCRIPTIONS_QUERY;
//# sourceMappingURL=getSubscriptions.js.map